<template>
  <div class="page mescroll-touch" v-show="showAll">
    <div class="model">
      <div class="modeltoprow">
        <div class="modeltitle">设置基本信息</div>
      </div>
      <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">您的身份</div>
          <div class="modelinnr">
            <van-field v-model="shenfen" readonly placeholder="请选择您的身份" @click="showPopupsf = true" />
            <van-popup v-model="showPopupsf" position="bottom">
              <van-cascader v-model="cascaderValuesf" title="请选择您的身份" :options="optionssf" :field-names="fieldNames1"
                @close="showPopupsf = false" @finish="onFinishsf" />
            </van-popup>
            <!-- <el-select v-model="shenfen" placeholder="请选择您的身份" class="select"
                            popper-class="popper-scrollbar-show">
                            <el-option v-for="item in optionssf" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select> -->
          </div>
        </div>
      </div>
      <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">姓名</div>
          <div class="modelinnr">
            <input type="text" v-model="Name" class="input" placeholder="请输入姓名" />
          </div>
        </div>
      </div>
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">性别</div>
          <div class="modelinnr">
            <el-radio class="" v-model="sex" label="男" border>男</el-radio>
            <el-radio class="" v-model="sex" label="女" border>女</el-radio>
          </div>
        </div>
      </div> -->
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">出生年月</div>
          <div class="modelinnr">
            <el-date-picker v-model="date" type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div> -->
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">身份证号</div>
          <div class="modelinnr">
            <input
              type="text"
              v-model="sfznum"
              class="input"
              placeholder="请输入身份证号"
            />
          </div>
        </div>
      </div> -->
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">政治面貌</div>
          <div class="modelinnr">
            <van-field
              v-model="zzmm"
              readonly
              placeholder="请选择您的政治面貌"
              @click="showPopupzzmm = true"
            />
            <van-popup v-model="showPopupzzmm" position="bottom">
              <van-cascader
                v-model="cascaderValuezzmm"
                title="请选择您的政治面貌"
                :options="optionszz"
                :field-names="fieldNames1"
                @close="showPopupzzmm = false"
                @finish="onFinishzzmm"
              />
            </van-popup>
          </div>
        </div>
      </div> -->
    </div>

    <div class="model">
      <div class="modeltoprow">
        <div class="modeltitle">设置专业信息</div>
      </div>
      <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">所在单位</div>
          <div class="modelinnr">
            <el-autocomplete type="text" v-model="hospital" class="input" placeholder="请输入关键字搜索所在单位"
              :fetch-suggestions="hospitalSearchAsync" popper-class="popper-scrollbar-show"
              :popper-append-to-body="false"></el-autocomplete>
          </div>
        </div>
      </div>
      <div class="modelrow" v-if="shenfen == '医务工作者'">
        <div class="modelinner">
          <div class="modelinname">科室</div>
          <div class="modelinnr">
            <van-field v-model="keshi" readonly placeholder="请选择您的科室" @click="showPopup1 = true" />
            <van-popup v-model="showPopup1" position="bottom">
              <van-cascader v-model="cascaderValue1" title="请选择您的科室" :options="optionskeshi" :field-names="fieldNames1"
                @close="showPopup1 = false" @finish="onFinish1" />
            </van-popup>
          </div>
        </div>
      </div>
      <div class="modelrow" v-if="shenfen == '医务工作者'">
        <div class="modelinner">
          <div class="modelinname">职称</div>
          <div class="modelinnr">
            <van-field v-model="jobTitle" readonly placeholder="请选择职称" @click="showPopup2 = true" />
            <van-popup v-model="showPopup2" position="bottom">
              <van-cascader v-model="cascaderValue2" title="请选择职称" :options="options2" :field-names="fieldNames1"
                @close="showPopup2 = false" @finish="onFinish2" />
            </van-popup>
          </div>
        </div>
      </div>
      <div class="modelrow" v-if="shenfen == '医药科研及非公医疗机构医务工作者'">
        <div class="modelinner">
          <div class="modelinname">职务</div>
          <div class="modelinnr">
            <input type="text" v-model="job" class="input" placeholder="请输入职务" />
          </div>
        </div>
      </div>
      <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">专业擅长</div>
          <div class="modelinnr">
            <el-select v-model="zhuanyesc" multiple filterable allow-create default-first-option
              placeholder="请输入或选择专业擅长" popper-class="popper-scrollbar-show">
              <el-option v-for="item in optionzzsc" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="model">
      <div class="modeltoprow">
        <div class="modeltitle">其他信息</div>
      </div>
      <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">邮箱</div>
          <div class="modelinnr">
            <input type="text" v-model="Mail" class="input" placeholder="请输入邮箱" />
          </div>
        </div>
      </div>
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname">通讯地址</div>
          <div class="modelinnr">
            <input type="text" v-model="place" class="input" placeholder="请输入通讯地址" />
          </div>
        </div>
      </div> -->
      <!-- <div class="modelrow">
        <div class="modelinner">
          <div class="modelinname1">证明材料（胸牌，证书）</div>
          <div class="modelinnr1">
            <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1" />
          </div>
        </div>
      </div> -->
    </div>
    <div class="submit" @click="submit">确认提交</div>
    <!-- <div class="submit" @click="noin()">升级中，敬请期待！</div> -->
    <div style="height: 35px; line-height: 35px"></div>
  </div>
</template>
<script>
export default {
  components: {},
  name: "newrenzheng",
  data() {
    return {
      optionssf: [
        {
          value: "医务工作者",
          Name: "医务工作者",
        },
        {
          value: "医药科研及非公医疗机构医务工作者",
          Name: "医药科研及非公医疗机构医务工作者",
        },
      ],
      shenfen: "",
      Name: "",
      // sex: "",
      // date: "",
      // sfznum: "",
      // zzmm: "",
      optionszz: [
        {
          value: "中共党员",
          Name: "中共党员",
        },
        {
          value: "九三学社社员",
          Name: "九三学社社员",
        },
        {
          value: "民革党员",
          Name: "民革党员",
        },
        {
          value: "民盟盟员",
          Name: "民盟盟员",
        },
        {
          value: "民建会员",
          Name: "民建会员",
        },
        {
          value: "民进会员",
          Name: "民进会员",
        },
        {
          value: "农工党党员",
          Name: "农工党党员",
        },
        {
          value: "致公党党员",
          Name: "致公党党员",
        },
        {
          value: "台盟盟员",
          Name: "台盟盟员",
        },
        {
          value: "无党派人士",
          Name: "无党派人士",
        },
        {
          value: "群众",
          Name: "群众",
        },
      ],
      // Phone: "",
      Mail: "",
      // place: "",
      hospital: "",
      hospitalList: [],
      timeout: null,
      keshi: "", //科室
      optionskeshi: [
        {
          value: "皮肤性病科",
          Name: "皮肤性病科",
        },
        {
          value: "医疗美容科",
          Name: "医疗美容科",
        },
        {
          value: "整形外科",
          Name: "整形外科",
        },
        {
          value: "中医科",
          Name: "中医科",
        },
        {
          value: "中西医结合科",
          Name: "中西医结合科",
        },
        {
          value: "其他科室/部门",
          Name: "其他科室/部门",
        },
      ],
      show: false,
      jobTitle: "", //职称
      job: "", //职务
      cascaderValue: "",
      cascaderValuesf: "",
      cascaderValuezzmm: "",
      optionszc: [
        {
          text: "医师",
          value: "医师",
          children: [
            { text: "助理医师", value: "助理医师" },
            { text: "住院医师", value: "住院医师" },
            { text: "主治医师", value: "主治医师" },
            { text: "副主任医师", value: "副主任医师" },
            { text: "主任医师", value: "主任医师" },
          ],
        },
        {
          text: "护士",
          value: "护士",
          children: [
            { text: "护士", value: "护士" },
            { text: "护师", value: "护师" },
            { text: "主管护师", value: "主管护师" },
            { text: "副主任护师", value: "副主任护师" },
            { text: "主任护师", value: "主任护师" },
          ],
        },
        {
          text: "药师",
          value: "药师",
          children: [
            { text: "药士", value: "药士" },
            { text: "药师", value: "药师" },
            { text: "主管药师", value: "主管药师" },
            { text: "副主任药师", value: "副主任药师" },
            { text: "主任药师", value: "主任药师" },
          ],
        },
        {
          text: "技师",
          value: "技师",
          children: [
            { text: "技士", value: "技士" },
            { text: "技师", value: "技师" },
            { text: "主管技师", value: "主管技师" },
            { text: "副主任技师", value: "副主任技师" },
            { text: "主任技师", value: "主任技师" },
          ],
        },
      ],
      zhuanyesc: "",
      optionzzsc: [
        {
          value: "毛发",
          label: "毛发",
        },
        {
          value: "儿童皮肤病",
          label: "儿童皮肤病",
        },
        {
          value: "光电美容",
          label: "光电美容",
        },
        {
          value: "注射美容",
          label: "注射美容",
        },
        {
          value: "皮肤外科",
          label: "皮肤外科",
        },
        {
          value: "皮肤肿瘤",
          label: "皮肤肿瘤",
        },
        {
          value: "皮肤影像",
          label: "皮肤影像",
        },
        {
          value: "皮肤病理",
          label: "皮肤病理",
        },
        {
          value: "性传播疾病",
          label: "性传播疾病",
        },
        {
          value: "医学真菌",
          label: "医学真菌",
        },
        {
          value: "结缔组织病",
          label: "结缔组织病",
        },
        {
          value: "基础及临床科学研究",
          label: "基础及临床科学研究",
        },
        {
          value: "银屑病",
          label: "银屑病",
        },
        {
          value: "色素性皮肤病",
          label: "色素性皮肤病",
        },
        {
          value: "特应性皮炎",
          label: "特应性皮炎",
        },
        {
          value: "新媒体传播",
          label: "新媒体传播",
        },
        {
          value: "中医皮肤病",
          label: "中医皮肤病",
        },
        {
          value: "玫瑰痤疮",
          label: "玫瑰痤疮",
        },
        {
          value: "大疱性皮肤病",
          label: "大疱性皮肤病",
        },
        {
          value: "痤疮",
          label: "痤疮",
        },
        {
          value: "功效性护肤品研究",
          label: "功效性护肤品研究",
        },
      ],
      // imgList: [],
      fileUrl: "",
      showPopup1: false,
      showPopupsf: false,
      showPopupzzmm: false,
      showPopup2: false,
      cascaderValue1: "",
      cascaderValue2: "",
      options1: [],
      options2: [],
      fieldNames1: {
        text: "Name",
        value: "Name",
        children: "Items",
      },
      userlist: [],
      showAll: false,
    };
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
    // this.noin();
    this.getinfo();
    this.getkeshi();
    this.getzhicheng();
    if (screen.orientation && screen.orientation.lock) {
      screen.orientation
        .lock("portrait")
        .then(() => {
          console.log("屏幕已锁定为竖屏");
        })
        .catch((error) => {
          console.error("屏幕锁定失败:", error);
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => { });
  },
  beforeDestroy() { },
  methods: {
    onFinish({ selectedOptions }) {
      this.show = false;
      this.jobTitle = selectedOptions.map((option) => option.text).join("/");
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/api/web/ImgFile/UploadImg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            this.fileUrl = res.Data.Url;
          }
        });
    },
    hospitalSearchAsync(queryString, cb) {
      let that = this;
      this.hospitalList = [];
      this.$axios
        .post("/api/api/web/customer/HospitalSearch", {
          Title: queryString,
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            res.Data.forEach((element) => {
              that.hospitalList.push({ value: element });
            });
            cb(that.hospitalList);
          }
        });
    },
    onFinish1({ selectedOptions }) {
      this.showPopup1 = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.keshi = selectedOptions.map((option1) => option1.Name).join("/");
      // console.log(this.hosstr)
    },
    onFinishsf({ selectedOptions }) {
      this.showPopupsf = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.shenfen = selectedOptions.map((option1) => option1.Name).join("/");
      // console.log(this.hosstr)
    },
    onFinishzzmm({ selectedOptions }) {
      this.showPopupzzmm = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.zzmm = selectedOptions.map((option1) => option1.Name).join("/");
      // console.log(this.hosstr)
    },
    onFinish2({ selectedOptions }) {
      this.showPopup2 = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.jobTitle = selectedOptions.map((option2) => option2.Name).join("/");
      // console.log(this.hosstr)
    },
    getkeshi() {
      this.options1 = [];
      this.$axios.get("/api/api/web/Customer/GetDepartment").then((res) => {
        this.options1 = res.Data;
      });
    },
    getzhicheng() {
      this.options2 = [];
      this.$axios.get("/api/api/web/Customer/GetJobTitle").then((res) => {
        this.options2 = res.Data;
      });
    },
    getinfo() {
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        const source = this.$route.query.s;
        if (source) {
          console.log("source", source);
          let param = { Source: source };
          this.$axios
            .post("/api/api/web/Customer/ACMEDVisitLog", param)
            .then((res) => { });
        }
        if (res.Data.ACMEDIdentity) {
          if (res.Data.ACMEDIdentity.Status == 70) {
            //信息已提交
            // this.$router.push("/newok");
            this.$router.replace({ path: "/newenterdone" });
          } else {
            //审核成功
            // this.$router.push("/uploadInfo");
            this.$router.replace({ path: "/newenterin" });
          }
        } else {
          this.showAll = true;
        }
        this.userlist = res.Data;
        console.log("用户信息", this.userlist);
        if (this.userlist.BaseInfo.RegistType == 10) {
          this.shenfen = "医务工作者";
          this.Name = this.userlist.BaseInfo.RealName;
          this.hospital = this.userlist.BaseInfo.Hospital;
          this.keshi = this.userlist.BaseInfo.HospitalDepartment;
          this.jobTitle = this.userlist.BaseInfo.HospitalJobTitle;
        } else if (this.userlist.BaseInfo.RegistType == 20) {
          this.shenfen = "医务工作者";
          this.Name = this.userlist.BaseInfo.RealName;
          this.hospital = this.userlist.BaseInfo.Hospital;
          this.keshi = this.userlist.BaseInfo.HospitalDepartment;
          this.jobTitle = this.userlist.BaseInfo.HospitalJobTitle;
        } else if (this.userlist.BaseInfo.RegistType == 30) {
          this.shenfen = "医药科研及非公医疗机构医务工作者";
          this.Name = this.userlist.BaseInfo.RealName;
          this.hospital = this.userlist.BaseInfo.Company;
          this.job = this.userlist.BaseInfo.CompanyJobTitle;
          // this.beizhu = this.userlist.CompanyNotes;
        }
      });
    },
    noin() {
      this.$dialog
        .alert({
          title: "提示",
          message: "升级中，敬请期待！",
        })
        .then(() => { });
    },
    submit() {
      let param = {
        Identity: this.shenfen,
        Name: this.Name,
        // Gender: this.sex,
        Unit: this.hospital,
        Department: this.keshi,
        // JobTitle: this.jobTitle,
        // IDCode: this.sfznum,
        // PoliticalStatus: this.zzmm,
        // Mobile: this.Phone,
        Mail: this.Mail,
        // Address: this.place,
        // GoodAt: this.zhuanyesc,
        CertificateUrl: this.fileUrl,
        // Birthday: this.date,
      };
      if (this.shenfen == "医务工作者") {
        param.JobTitle = this.jobTitle;
      } else if (this.shenfen == "医药科研及非公医疗机构医务工作者") {
        param.JobTitle = this.job;
      }
      if (this.zhuanyesc) {
        param.GoodAt = this.zhuanyesc.join(",");
      }
      console.log(param);
      if (
        param.Identity &&
        param.Name &&
        param.Unit &&
        param.Mail
      ) {
        if (param.Identity == "医务工作者") {
          if (!param.Department) {
            this.$message({
              showClose: true,
              message: "请选择您的科室",
              type: "warning",
            });
          } else if (!param.JobTitle) {
            this.$message({
              showClose: true,
              message: "请选择您的职称",
              type: "warning",
            });
          } else {
            console.log("qy");
            this.$axios
              .post("/api/api/web/customer/SubmitACMEDIdentity", param)
              .then((res) => {
                if (res.RetCode == 10000) {
                  this.$message({ message: "提交成功！", type: "success" });
                  // this.$router.push({ path: "newok" });
                  this.$router.replace({ path: "/newenterin" });
                }
              });
          }
        } else if (param.Identity == "医药科研及非公医疗机构医务工作者") {
          if (!param.JobTitle) {
            this.$message({
              showClose: true,
              message: "请填写您的职务",
              type: "warning",
            });
          } else {
            console.log("qy");
            this.$axios
              .post("/api/api/web/customer/SubmitACMEDIdentity", param)
              .then((res) => {
                if (res.RetCode == 10000) {
                  this.$message({ message: "提交成功！", type: "success" });
                  // this.$router.push({ path: "newok" });
                  this.$router.replace({ path: "/newenterin" });
                }
              });
          }
        }

      } else if (!param.Name) {
        this.$message({
          showClose: true,
          message: "请输入您的姓名",
          type: "warning",
        });
      } else if (!param.Identity) {
        this.$message({
          showClose: true,
          message: "请选择您的身份",
          type: "warning",
        });
      } else if (!param.Unit) {
        this.$message({
          showClose: true,
          message: "请选择您的所在单位",
          type: "warning",
        });
      } else if (!param.GoodAt) {
        this.$message({
          showClose: true,
          message: "请选择您的专业擅长",
          type: "warning",
        });
      } else if (!param.Mail) {
        this.$message({
          showClose: true,
          message: "请输入您的邮箱",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  background: rgb(248, 248, 248);
  width: 100%;
  height: 100%;
  padding: 2vh 0;
  max-width: 640px;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
}

.model {
  width: 95%;
  background: #fff;
  border-radius: 8px;
  margin: auto;
  padding: 0.2rem;
  // margin-top: 2rem;
  box-sizing: border-box;
  margin-bottom: 0.3rem;
}

.modeltitle {
  border-left: 4px solid #2c4e8b;
  font-weight: bold;
  font-size: 18px;
  box-sizing: border-box;
  padding-left: 0.2rem;
}

.modeltoprow {
  margin: 0.2rem 0;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 0.2rem;
  padding-bottom: 0.3rem;
  box-sizing: border-box;
}

.modelrow {
  margin: 0.3rem 0;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 0.2rem;
  padding-bottom: 0.3rem;
  box-sizing: border-box;
}

.modelinner {
  display: flex;
  flex-direction: row;
  font-size: 17px;
}

.modelinname {
  width: 30%;
  // padding: .1rem 0
}

.modelinname1 {
  width: 70%;
  // padding: .1rem 0
}

.modelinnr {
  width: 70%;
  // padding: .1rem 0;
  text-align: right;
}

.modelinnr1 {
  width: 30%;
  // padding: .1rem 0;
  text-align: right;
}

.input {
  width: 100%;
  text-align: right;
  border: 1px solid #fff;
  font-size: 15px;
  color: #636363;
}

.input::placeholder {
  color: #c4c4c4;
}

.select {
  width: 100%;
}

::v-deep .el-input__inner {
  border: 0.026667rem solid #fff;
  border-color: #fff !important;
  text-align: right;
  width: 100%;
  padding-right: 0;
  height: 100%;
  line-height: unset;
}

::v-deep .el-input__icon {
  line-height: unset;
}

::v-deep .el-input__suffix {
  // right: -10px;
  display: none;
}

.el-radio {
  margin-right: 0;
  height: 100%;
  padding-top: 5px;
  box-sizing: border-box;
}

::v-deep .el-icon-date {
  display: none;
}

::v-deep .van-cell {
  padding: 0;
  // transform: translateX(3%);
}

::v-deep .van-cell__right-icon {
  color: #d3d3d3;
}

::v-deep .van-field__control {
  text-align: right;
}

::v-deep .van-cell__left-icon,
.van-cell__right-icon {
  font-size: unset;
}

::v-deep .el-select-dropdown {
  left: 50% !important;
  width: 100% !important;
  transform: translateX(-50%) !important;
  padding-bottom: 0.3rem !important;
}

.submit {
  width: 80%;
  margin: auto;
  height: 35px;
  line-height: 35px;
  border-radius: 35px;
  background-color: #1d2a5a;
  color: #ffffff;
  text-align: center;
  margin-bottom: 20px;
}

.popper-scrollbar-show {
  .el-scrollbar__bar.is-vertical {
    display: block !important;
    opacity: 1 !important;
  }
}

::v-deep .el-autocomplete-suggestion li {
  white-space: normal !important;
  word-wrap: break-word !important;
  text-align: left !important;
  line-height: 0.5rem !important;
  margin-bottom: 0.4rem !important;
}
</style>